import { createSelector } from 'reselect';
import { isEmpty } from 'lodash';

export const getFieldPermissions = createSelector(({ acl }) => acl.fieldPermissions, result => result);

export const getFormActions = createSelector(({ acl }) => acl.formActions, result => result);

export const getAclString = createSelector(({ acl }) => acl.aclString, result => result);

export const getIsAdmin = createSelector(({ acl }) => (
  isEmpty(acl.aclString)
    ? false
    : acl.aclString.split(',').includes('ADMIN')), result => result);

export const getMainActions = createSelector(({ acl }) => acl.mainActions, result => result);

export const getFormPermissions = createSelector(({ acl }) => acl.formPermissions, result => result);

export const getPagePermissions = createSelector(({ acl }) => acl.pagePermissions, result => result);

export const getError = createSelector(({ acl }) => acl.error, result => result);

export const getLoading = createSelector(({ acl }) => acl.loading, result => result);

export const getMultiLoading = createSelector(({ acl }) => acl.actionLoadingStatuses, result => result);

export const getCompleted = createSelector(({ acl }) => acl.actionsComplete, result => result);
